
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assessments/[id]/[slug]",
      function () {
        return require("private-next-pages/assessments/[id]/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assessments/[id]/[slug]"])
      });
    }
  